import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { gql } from 'apollo-angular';
import { ApolloService } from 'src/app/services/apollo/apollo.service';
import { GraphQLError } from 'src/app/services/apollo/graphql-payload.type';
import { GetFeatureMetadataQuery } from 'src/graphql/types/api.types';
import * as queries from 'src/graphql/queries';

@Injectable({ providedIn: 'root' })
export class FeatureMetadataService {
  constructor(private apolloService: ApolloService) {}

  getFeatureMetadata(): Observable<[GetFeatureMetadataQuery['getFeatureMetadata'], GraphQLError]> {
    return this.apolloService
      .query<GetFeatureMetadataQuery>({
        query: gql(queries.getFeatureMetadata),
      })
      .pipe(
        map(([result, error]) => {
          if (error) return [null, error];
          return [result.getFeatureMetadata, null];
        }),
      );
  }
}
